// extracted by mini-css-extract-plugin
export default {"leads":"MyLeads_leads__EI5Ia","reportStatuses":"MyLeads_reportStatuses__d25jg","actions":"MyLeads_actions__KtcF8"};